import { TrackingManager } from "../../../common/js/services/tracking/trackingManager"

export default (commonBasicPlanCheckout) =>
  ({ planSelectionPath, paymentsPath, isTrackVisitCheckout, isAbandonedBasket } = {}) => ({
    // Init basic common checkout functionality

    ...commonBasicPlanCheckout({
      planSelectionPath,
      paymentsPath,
      isTrackVisitCheckout,
      isAbandonedBasket,
    }),

    internalTracker: new TrackingManager(
      window.trackingConfig.enabledTrackingServices,
      pipelineConfig,
    ),


    init() {
      this.commonInit()
    },

    submitOffer() {
      if (!this.store.values.privacyAgreement) {
        this.privacyAgreementError = true

        this.internalTracker.trackClick({ clickName: "Get Plan Blocked By Policy" })
        return
      }
      this.internalTracker.setEventToSessionStorage({ clickName: "Get Plan Clicked" })

      this.commonSubmitOffer()
    },
  })
